import Api from '@/services/Index';

const register = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/start-application', data);
}
const verify = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/verify-application', data);
}
const continueApplication = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/visitorstudent/application/continue-application', config);
}
const login = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/login', data);
}
const pinReminder = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/visitorstudent/application/pin-reminder", data);
};
const updateInformation = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/update-information', data);
}
const updateProgramSelection = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/update-program-selection', data);
}
const sectionList = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/section-list', data);
}
const updateCourseRegistration = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/update-course-registration', data);
}
const addDocument = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/add-document', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}
const summary = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/summary', data);
}
const submitApplication = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/submit', data);
}
const excelExport = (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/visitorstudent/application/excel-export',{...config,responseType:"arraybuffer"});
}
const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/visitorstudent/applications/'+id);
}

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/visitorstudent/applications' ,config);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/visitorstudent/applications/' + id);
}

const evaluate = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/visitorstudent/applications/' + id + '/evaluate', data);
}

const downloadForm = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/visitorstudent/applications/' + id + '/download-form', { responseType: 'arraybuffer' });
}

const courseApprovalList = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/course-approval-list', data);
}

const courseApproval = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/course-approval', data);
}

const onlineRegistrationDefaultData = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/online-registration-default-data', data);
}

const download = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/visitorstudent/application/download-document/' + id, formData, {responseType: "arraybuffer"});
}
const evaluateDocument = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/visitorstudent/applications/${id}/evaluate-document`, data);
}
const evaluateCourse = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/visitorstudent/applications/${id}/evaluate-course`, data);
}
const updateStatuses = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/visitorstudent/applications/${id}/update-statuses`, data);
}

export default {
    register,
    verify,
    login,
    pinReminder,
    updateInformation,
    updateProgramSelection,
    continueApplication,
    sectionList,
    updateCourseRegistration,
    addDocument,
    summary,
    submitApplication,
    excelExport,
    del,
    getAll,
    get,
    evaluate,
    downloadForm,
    courseApprovalList,
    courseApproval,
    onlineRegistrationDefaultData,
    download,
    evaluateDocument,
    evaluateCourse,
    updateStatuses
}
